import { render, staticRenderFns } from "./create-bookmark.vue?vue&type=template&id=2f596fb3&scoped=true&"
import script from "./create-bookmark.vue?vue&type=script&lang=js&"
export * from "./create-bookmark.vue?vue&type=script&lang=js&"
import style0 from "./create-bookmark.vue?vue&type=style&index=0&id=2f596fb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f596fb3",
  null
  
)

export default component.exports